<script lang="ts">
import type { Announcement } from "$lib/notice";

// What a visitor sees while the service is fully closed.
//
// Server-rendered and complete without a script, because the moment it is shown
// is the moment nothing else about the deployment can be relied on. It says the
// three things a person needs — it is deliberate, nothing was charged, come
// back — plus whatever the operator wrote, as plain text.

let { announcement = null }: { announcement?: Announcement | null } = $props();
</script>

<main class="mx-auto flex min-h-[60vh] max-w-2xl flex-col justify-center px-6 py-16">
  <h1 class="text-2xl font-semibold text-slate-900" data-testid="maintenance-title">
    Down for maintenance
  </h1>
  <p class="mt-4 text-slate-700">
    The service is closed for planned work right now. Nothing has been charged, and nothing you have
    stored is affected.
  </p>
  {#if announcement}
    <p
      class="mt-6 rounded-lg border border-slate-200 bg-white px-4 py-3 text-slate-800"
      data-testid="maintenance-announcement"
    >
      {announcement.text}
    </p>
  {/if}
  <p class="mt-6 text-sm text-slate-500">
    Please try again shortly. The API answers <code class="font-mono">503</code> with a
    <code class="font-mono">Retry-After</code> header while this lasts, so a client that honours it
    resumes on its own.
  </p>
  <!-- The one address this page can offer, and the one it is safe to offer: it
       is exempt from the closure, so the link works while everything else on
       the site is behind this wall ($lib/notice.ts). -->
  <p class="mt-4 text-sm">
    <a href="/status" class="font-medium text-slate-900 underline" data-testid="maintenance-status">
      See our status page
    </a>
    <span class="text-slate-500"> for what is running and what is not.</span>
  </p>
</main>
